
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-plan",
      function () {
        return require("private-next-pages/talent-plan/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent-plan"])
      });
    }
  